export default function AdminComingSoon({ title = "功能建设中", desc }) {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-800 mb-6">{title}</h1>
      <div className="bg-white rounded-2xl shadow p-10">
        <p className="text-gray-500">
          {desc || "这个模块先预留入口，后续再接具体业务。"}
        </p>
      </div>
    </div>
  );
}